import type { Maybe } from '@/frontend-types'
import Link from 'next/link'
import type { ComponentProps, FC } from 'react'

export type BreadcrumbLinkType = Omit<ComponentProps<typeof Link>, 'href' | 'children'> & {
	href: Maybe<string>
	label: Maybe<string>
}

const classes =
	'flex items-center gap-x-xs text-body-xs text-blue group hover:text-blue-shade-40 focus:text-blue-shade-70'
const labelClasses =
	'relative block after:content-[""] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-px after:bg-blue after:transition-all after:duration-200 after:ease-in-out group-hover:after:bg-blue-shade-40 group-active:after:bg-blue-shade-70 group-hover:after:w-full group-active:after:w-full'

const BreadcrumbLink: FC<BreadcrumbLinkType> = ({ href, label, ...props }) => {
	if (href) {
		return (
			<Link className={classes} href={href} {...props}>
				<span className={labelClasses}>{label}</span>
			</Link>
		)
	}
	return <span className={classes}>{label}</span>
}

export default BreadcrumbLink
